// extracted by mini-css-extract-plugin
export default {"list":"list--sRTJg","visibleChip":"visibleChip--K2dCa","inActiveFilterChip":"inActiveFilterChip--vuCat"};